import React, { useEffect, useState } from 'react';
import axios from '../axiosInstance';

const Leaderboard = () => {
  const [banners, setBanners] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const fetchBanners = async (pageNumber = 1) => {
    try {
      const res = await axios.get(`/api/banners?page=${pageNumber}`);
      setBanners(res.data);
      // Replace this with res.data.totalPages if your backend returns it
      setTotalPages(Math.ceil(100 / 20));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBanners(page);
  }, [page]);

   // === NOUVEAU AADS ADAPTATIF (mobile + desktop) ===
useEffect(() => {
  const div = document.createElement("div");
  div.innerHTML = `
    <!-- BEGIN AADS AD UNIT 2425494 -->   
    <!-- END AADS AD UNIT 2425494 -->
  `;
  document.body.appendChild(div);
  return () => document.body.removeChild(div);
}, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans overflow-hidden">
      {/* NAVBAR - same modern cyber style as the new Home */}
      <header className="bg-gray-900/95 backdrop-blur-xl border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl 2xl:max-w-none mx-auto px-4 sm:px-6 2xl:px-10 py-4 sm:py-5">
          <div className="flex items-center justify-between">
            
            {/* Logo + Hamburger (visible seulement mobile) */}
            <div className="flex items-center gap-4">
              <img 
                src="/bannerRank.png" 
                alt="RankMyBanner" 
                className="h-9 sm:h-10 w-auto drop-shadow-[0_0_15px_rgb(16,185,129)]" 
              />
              
              {/* Hamburger - visible < md */}
              <button 
                type="button" 
                className="md:hidden text-emerald-400 focus:outline-none"
                aria-label="Toggle menu"
                onClick={() => setIsOpen(!isOpen)}
              >
                {/* SVG hamburger ou croix selon isOpen */}
                  {isOpen ? (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
              </button>
            </div>

            {/* Navigation */}
            <nav
                  className={`
                    ${isOpen ? 'block' : 'hidden'}              // affiche/cache sur mobile quand on clique
                    md:flex md:items-center                     // sur desktop → toujours visible + flex horizontal
                    absolute md:static top-full left-0 right-0  // position absolute sur mobile pour dropdown
                    bg-gray-900/95 md:bg-transparent            // fond sombre sur mobile, transparent sur desktop
                    border-b border-gray-800 md:border-none     // bordure basse sur mobile uniquement
                    p-6 md:p-0                                  // padding plus important sur mobile
                    flex flex-col md:flex-row                   // colonne sur mobile, ligne sur desktop
                    gap-6 md:gap-x-8 md:gap-y-0                 // espacement adapté
                    text-sm font-medium                         // style texte
                    z-40                                        // au-dessus du reste si besoin
                  `}
                >
              <a href="/" className="hover:text-emerald-400 transition hover:text-emerald-300">Home</a>
              <a href="/leaderboard" className="text-emerald-400 font-semibold transition">Leaderboard</a>
              <a href="/submit" className="hover:text-emerald-400 transition">Submit Your Banner</a>
              <a href="/claim" className="hover:text-emerald-400 transition">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-emerald-400 transition">How to Increase</a>
            </nav>

            {/* Pub – cachée sur < 2xl */}
            <div className="hidden 2xl:block flex-shrink-0">
              <iframe 
                src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
                width="728" 
                height="90" 
                scrolling="no" 
                border="0" 
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </header>

      {/* LEADERBOARD CONTENT - cyber neon style */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-6">
          {/* Hero-style header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-emerald-500/10 border border-emerald-500/30 px-8 py-3 rounded-3xl text-emerald-400 font-medium mb-6 shadow-[0_0_30px_rgb(16,185,129,0.3)]">
              <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse" /> 
              LIVE GLOBAL RANKING
            </div>
            <h1 className="text-6xl md:text-7xl font-black tracking-[-3px] leading-none mb-4 bg-clip-text text-transparent bg-gradient-to-r from-white via-emerald-200 to-teal-300">
              GLOBAL LEADERBOARD
            </h1>
            <p className="text-2xl text-gray-400 max-w-2xl mx-auto">
              Top banners ranked by points • Updated every 24 hours • Resets monthly
            </p>
          </div>

          {/* Modern table with glassmorphism + neon hover */}
          <div className="overflow-x-auto rounded-3xl border border-gray-800 bg-gray-900/80 backdrop-blur-xl shadow-2xl shadow-emerald-500/10">
            <table className="min-w-[1200px] w-full">
              <thead className="bg-gray-950 text-left text-sm uppercase tracking-[2px] border-b border-emerald-500/20">
                <tr>
                  <th className="px-10 py-6 font-bold text-emerald-400 border-r border-gray-800">RANK</th>
                  <th className="px-10 py-6 font-bold text-emerald-400 border-r border-gray-800">BANNER</th>
                  <th className="px-10 py-6 font-bold text-emerald-400 border-r border-gray-800">EARNING LINK</th>
                  <th className="px-10 py-6 font-bold text-emerald-400 border-r border-gray-800">DESCRIPTION</th>
                  <th className="px-10 py-6 font-bold text-emerald-400">POINTS</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {banners.map((banner, index) => (
                  <tr 
                    key={banner.id} 
                    className="hover:bg-emerald-950/30 hover:border-emerald-500/30 group transition-all duration-300"
                  >
                    <td className="px-10 py-7 font-black text-3xl text-emerald-400 border-r border-gray-800">
                      #{(page - 1) * 20 + index + 1}
                    </td>

                    <td className="px-10 py-7 border-r border-gray-800">
                      <div className="w-[468px] h-[90px] flex-shrink-0 bg-gray-950 rounded-2xl overflow-hidden flex items-center justify-center border border-gray-800 group-hover:border-emerald-500/50 transition">
                        <a href={banner.target_url} target="_blank" rel="noopener noreferrer">
                          <img
                            src={banner.image_url}
                            alt={`Banner ${index}`}
                            className="max-h-[90px] w-auto object-contain group-hover:scale-110 transition duration-500"
                          />
                        </a>
                      </div>
                    </td>

                    <td className="px-10 py-7 border-r border-gray-800 break-all">
                      <a
                        href={`https://rankmybanner.click/visit/${banner.slug}`}
                        className="text-blue-400 hover:text-blue-300 hover:underline font-mono text-sm tracking-wider block"
                      >
                        rankmybanner.click/visit/{banner.slug}
                      </a>
                    </td>

                    <td className="px-10 py-7 text-gray-300 border-r border-gray-800 text-sm leading-relaxed">
                      {banner.description}
                    </td>

                    <td className="px-10 py-7">
                      <span className="inline-block bg-emerald-500 text-black font-black px-7 py-2.5 rounded-2xl text-lg shadow-[0_0_20px_rgb(16,185,129)]">
                        {banner.points} PTS
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Modern pagination */}
          <div className="flex justify-center mt-12 gap-3">
            <button
              onClick={() => setPage(p => Math.max(p - 1, 1))}
              disabled={page === 1}
              className="px-8 py-4 bg-gray-900 border border-gray-700 hover:border-emerald-400 hover:text-emerald-400 rounded-3xl disabled:opacity-50 transition-all font-medium"
            >
              ← PREVIOUS
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => setPage(i + 1)}
                className={`px-7 py-4 rounded-3xl font-bold transition-all text-lg ${
                  page === i + 1 
                    ? 'bg-emerald-500 text-black shadow-[0_0_30px_rgb(16,185,129)]' 
                    : 'bg-gray-900 border border-gray-700 hover:border-emerald-400 hover:text-emerald-400'
                }`}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() => setPage(p => Math.min(p + 1, totalPages))}
              disabled={page === totalPages}
              className="px-8 py-4 bg-gray-900 border border-gray-700 hover:border-emerald-400 hover:text-emerald-400 rounded-3xl disabled:opacity-50 transition-all font-medium"
            >
              NEXT →
            </button>
          </div>
        </div>
      </section>

      {/* ZeroAds bottom banner */}
      <div className="flex justify-center py-12 bg-gray-900">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" height="90" scrolling="no" border="0" frameBorder="0"
        />
      </div>

      {/* FINAL CTA - same as Home */}
      <div className="py-28 bg-gradient-to-r from-emerald-950 via-black to-teal-950 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-6xl font-black tracking-tight mb-8">READY TO EXPLODE YOUR TRAFFIC?</h2>
          <a 
            href="/submit" 
            className="inline-block px-16 py-7 text-2xl font-bold bg-white text-black rounded-3xl hover:bg-emerald-400 hover:text-black transition-all scale-105 shadow-[0_0_60px_rgb(16,185,129)]"
          >
            SUBMIT MY BANNER → LET’S GO
          </a>
        </div>
      </div>

      {/* FOOTER - identical to new Home */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-gray-500">
            <div>© 2026 RankMyBanner • All Rights Reserved</div>
            <div className="flex gap-8">
              <a href="/" className="hover:text-gray-300">Home</a>
              <a href="/leaderboard" className="hover:text-gray-300">Leaderboard</a>
              <a href="/submit" className="hover:text-gray-300">Submit Your Banner</a>
              <a href="/claim" className="hover:text-gray-300">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-gray-300">How to Increase</a>
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Leaderboard;